import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { authStore } from '@/stores/AuthStore';
import { AppPhoneInput, AppButton, AppLogo, extractPhoneDigits } from '@pro-sto/ui';
import type { AppInputRef } from '@pro-sto/ui';
import { ROUTES } from '@/constants/routes';
import './AuthPhonePage.css';

const AuthPhonePage: React.FC = observer(() => {
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const phoneInputRef = useRef<AppInputRef>(null);

  const handlePhoneChange = () => {
    // Phone value is taken from ref directly
  };

  const handlePhoneValidate = (valid: boolean, cleanPhone: string) => {
    setIsValid(valid && cleanPhone.length === 10);
  };

  const handleSubmit = async () => {
    if (!isValid || authStore.isLoading) return;

    try {
      const inputValue = phoneInputRef.current?.value || '';
      const cleanPhone = extractPhoneDigits(inputValue);
      const formattedPhone = `+7${cleanPhone}`;

      await authStore.sendCode(formattedPhone);
      navigate(ROUTES.AUTH_CODE, { state: { phone: formattedPhone } });
    } catch (error) {
      console.error('Error sending code:', error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && isValid && !authStore.isLoading) {
      handleSubmit();
    }
  };

  return (
    <div className="auth-phone" data-testid="auth-phone-page">
      <div className="auth-phone__logo" data-testid="auth-logo">
        <AppLogo />
      </div>
      <h1 className="auth-phone__title" data-testid="auth-phone-title">Авторизация</h1>
      <div className="auth-phone__form">
        <div onKeyDown={handleKeyDown}>
          <AppPhoneInput
            ref={phoneInputRef}
            label="Номер телефона"
            placeholder="+7 (___) ___-__-__"
            onChange={handlePhoneChange}
            onValidate={handlePhoneValidate}
            disabled={authStore.isLoading}
            autoFocus
            data-testid="phone-input"
          />
        </div>
        <div className="auth-phone__button">
          <AppButton
            variant="primary"
            size="L"
            onClick={handleSubmit}
            disabled={!isValid || authStore.isLoading}
            loading={authStore.isLoading}
            data-testid="submit-phone-button"
          >
            Далее
          </AppButton>
        </div>
      </div>
    </div>
  );
});

AuthPhonePage.displayName = 'AuthPhonePage';

export default AuthPhonePage;
